import React from 'react';
import { Card } from './Card';
import { DoughnutChart } from '../charts/DoughnutChart';
import { BoxIcon } from '../icons/BoxIcon';
import { Diff } from '../Diff';
import { getDiff, getComparePresetLabel } from '../../model/Diff';
import { Information } from '../Information';
import { ComparePreset } from '../../model/datePicker/types';
import { t } from '../../i18n';

const TopInteractedCard = ({ name, count, previousCount, total, comparePreset }: Props) => {
  const mainColor = '#A162F7';
  const restColor = '#EDE2FF';
  const percentage = Math.round((count / total) * 100);
  const rest = 100 - percentage;
  const datasets = [{ data: [ { value: percentage, label: percentage + '%' }, { value: rest, label: rest + '%' } ], backgroundColor: [ mainColor, restColor ]}];
  const labels = [t('cards.interactions'), t('cards.rest')];
  return (
    <Card className="">
      <div className="card-body">
        <div className="row h-100">
          <div className="col-6 d-flex flex-column">
            <div className="d-flex align-items-center mb-4">
              <Information id="topInteractedProduct" content={<h5 className="card-title mb-lg-0 text-nowrap me-2">{t('cards.topInteractedProduct')}</h5>} />
              <Information id="topInteractedProduct" showMore={true} />
            </div>
            <div className="d-flex flex-grow-1 align-items-center mt-4 mb-4">
              <BoxIcon />
            </div>
            <span className="text-black">{name}</span>
            <small className="d-flex align-items-center text-nowrap">
              <Diff value={getDiff(count, previousCount)} />
              <div className="text-secondary">{getComparePresetLabel(comparePreset)} ({previousCount})</div>
            </small>
          </div>
          <div className="col-6 position-relative">
            <DoughnutChart datasets={datasets} labels={labels} />
            <div className="position-absolute text-center" style={{left: '50%', top: '50%', transform: 'translate(-50%, -50%)'}}>
              <div className="text-dark fs-5 lh-1">{count}</div>
              <div className="text-primary lh-1">{t('cards.interactionsLower')}</div>
            </div>
          </div>
        </div>
      </div>
    </Card>);
}

interface Props {
  name: string,
  count: number,
  previousCount: number,
  total: number,
  comparePreset?: ComparePreset
}

export { TopInteractedCard };